// Servizio API — comunicazione con backend PHP

const API_BASE = process.env.REACT_APP_API_URL || '/api';

async function request(url, options = {}) {
  const response = await fetch(url, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Errore API');
  }
  return data.data;
}

// Sessions
export const createSession = (sessionData) =>
  request(`${API_BASE}/sessions.php`, {
    method: 'POST',
    body: JSON.stringify(sessionData),
  });

export const getSession = (id) =>
  request(`${API_BASE}/sessions.php?id=${id}`);

export const getSessions = () =>
  request(`${API_BASE}/sessions.php`);

export const updateSession = (id, data) =>
  request(`${API_BASE}/sessions.php?id=${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });

// Actions
export const getActions = (sessionId) =>
  request(`${API_BASE}/actions.php?session_id=${sessionId}`);

export const saveAction = (actionData) =>
  request(`${API_BASE}/actions.php`, {
    method: 'POST',
    body: JSON.stringify(actionData),
  });

export const updateAction = (id, data) =>
  request(`${API_BASE}/actions.php?id=${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });

export const deleteAction = (id) =>
  request(`${API_BASE}/actions.php?id=${id}`, { method: 'DELETE' });

// Penalties
export const getPenalties = (sessionId) =>
  request(`${API_BASE}/penalties.php?session_id=${sessionId}`);

export const savePenalty = (penaltyData) =>
  request(`${API_BASE}/penalties.php`, {
    method: 'POST',
    body: JSON.stringify(penaltyData),
  });

export const deletePenalty = (id) =>
  request(`${API_BASE}/penalties.php?id=${id}`, { method: 'DELETE' });

// Athletes
export const getAthletes = () =>
  request(`${API_BASE}/athletes.php`);

export const getAthlete = (name) =>
  request(`${API_BASE}/athletes.php?name=${encodeURIComponent(name)}`);

// Export / Import
export const exportSession = (sessionId) =>
  request(`${API_BASE}/export.php?session_id=${sessionId}`);

export const importSession = (jsonData) =>
  request(`${API_BASE}/export.php`, {
    method: 'POST',
    body: JSON.stringify(jsonData),
  });

// Settings (keybindings, preferenze utente)
export const fetchSettings = () =>
  request(`${API_BASE}/settings.php`);

export const pushSettings = (settings) =>
  request(`${API_BASE}/settings.php`, {
    method: 'POST',
    body: JSON.stringify(settings),
  });
